/**
 * DrawerFooter — the CardDetailDrawer's bottom action bar: the short card
 * id on the left, Archive / Restore on the right.
 *
 * Extracted verbatim from CardDetailDrawer.tsx (operator 500-line ceiling).
 */
import { Archive, ExternalLink, Loader2, Trash2 } from 'lucide-react'
import type { Card } from '../../../types'
import type { DrawerEditing } from '../drawerHookTypes'

export interface DrawerFooterProps {
  card: Card
  editing: DrawerEditing
}

export function DrawerFooter({ card, editing }: DrawerFooterProps) {
  const { busyKey, setStatus, patchCard } = editing
  return (
    <footer className="flex items-center justify-between gap-2 border-t border-neutral-200 dark:border-neutral-800 px-4 py-3">
      <div className="flex items-center gap-2 text-[10px] text-neutral-400">
        <ExternalLink className="h-3 w-3" />
        <code className="font-mono">{card.id.slice(0, 8)}</code>
      </div>
      <div className="flex items-center gap-2">
        {card.status !== 'ARCHIVED' && (
          <button
            type="button"
            onClick={() => {
              setStatus('ARCHIVED')
              void patchCard('archive', { status: 'ARCHIVED' } as never)
            }}
            disabled={busyKey === 'archive'}
            className="inline-flex items-center gap-1 rounded-md border border-neutral-300 dark:border-neutral-700 px-2 py-1 text-[11px] font-medium text-neutral-700 dark:text-neutral-300 hover:bg-neutral-100 dark:hover:bg-neutral-800"
          >
            {busyKey === 'archive' ? (
              <Loader2 className="h-3 w-3 animate-spin" />
            ) : (
              <Archive className="h-3 w-3" />
            )}
            Archive
          </button>
        )}
        {card.status === 'ARCHIVED' && (
          <button
            type="button"
            onClick={() => {
              setStatus('OPEN')
              void patchCard('restore', { status: 'OPEN' } as never)
            }}
            disabled={busyKey === 'restore'}
            className="inline-flex items-center gap-1 rounded-md border border-neutral-300 dark:border-neutral-700 px-2 py-1 text-[11px] font-medium text-neutral-700 dark:text-neutral-300 hover:bg-neutral-100 dark:hover:bg-neutral-800"
          >
            <Trash2 className="h-3 w-3" />
            Restore
          </button>
        )}
      </div>
    </footer>
  )
}
